<form [formGroup]="holidayForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div class="mb-3">
      <app-date-picker
        formControlName="offset_date"
        label="Дата начала каникул"
        hint="ГГГГ-ММ-ДД"
        class="mb-5"
        [appearance]="'outline'"
        [formGroup]="holidayForm"
        [control]="offsetDate"
        [datePicker]="offsetDate"
        [prevDateDisabledKey]="true"
        [errorFromApi]="
          errors$ && errors$.offset_date ? errors$.offset_date[0] : null
        "
        [requiredErrorMessage]="requiredErrorMessage"></app-date-picker>
    </div>

    <mat-form-field appearance="outline" class="pb-4 pb-sm-2">
      <mat-label>Количество недель</mat-label>
      <input
        required
        matInput
        type="number"
        min="1"
        [errorStateMatcher]="matcher"
        formControlName="weeks_offset" />
      <mat-error *ngIf="offsetWeeks!.errors?.required">{{
        requiredErrorMessage
      }}</mat-error>
      <mat-error *ngIf="offsetWeeks!.errors?.min">
        Кол-во недель не должно быть меньше 1
      </mat-error>
      <mat-error>{{ getMessageFormError('weeks_offset') }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <div mat-dialog-actions class="justify-content-end">
    <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
      Отмена
    </button>

    <app-button-with-progress
      typeBtn="submit"
      [loading$]="sendLoading$ | async"
      [isDisabled]="holidayForm.invalid || (sendLoading$ | async)"
      label="Добавить"></app-button-with-progress>
  </div>
</form>
